import { RequirementType } from './scenarioRequirementDefinition.model';

/** maps to PersonScenarioRequirementModel */
export class PersonScenarioRequirement {
  public id: string;
  public status: PersonScenarioRequirementStatus;
  public scenarioRequirementDefinitionName: string;
  public scenarioRequirementDefinitionDescription: string;
  public type: RequirementType;
  public evidenceSnapshotTakenDate?: string;
  public evidenceSnapshotTakenBy?: string;
  constructor(
    id: string,
    status: PersonScenarioRequirementStatus,
    scenarioRequirementDefinitionName: string,
    scenarioRequirementDefinitionDescription: string,
    type: RequirementType,
    evidenceSnapshotTakenDate?: string,
    evidenceSnapshotTakenBy?: string
  ) {
    this.id = id;
    this.status = status;
    this.scenarioRequirementDefinitionName = scenarioRequirementDefinitionName;
    this.scenarioRequirementDefinitionDescription = scenarioRequirementDefinitionDescription;
    this.type = type;
    this.evidenceSnapshotTakenDate = evidenceSnapshotTakenDate;
    this.evidenceSnapshotTakenBy = evidenceSnapshotTakenBy;
  }

  static parse(obj: Partial<PersonScenarioRequirement>): PersonScenarioRequirement {
    if (obj == null) return null;
    return new PersonScenarioRequirement(
      obj.id,
      obj.status,
      obj.scenarioRequirementDefinitionName,
      obj.scenarioRequirementDefinitionDescription,
      obj.type,
      obj.evidenceSnapshotTakenDate,
      obj.evidenceSnapshotTakenBy
    );
  }
}

export enum PersonScenarioRequirementStatus {
  Complete = 'Complete',
  Incomplete = 'Incomplete',
}
